import { Link } from "react-router-dom";

// Fixed top navigation, à la a gallery site: text links left, artist name
// centred, a contact pill right. Links glide the hall to the right section.
function walkTo(selector) {
  const el = document.querySelector(selector);
  if (!el) return;
  const hall = document.querySelector(".hall");
  // If the target lives outside the hall (intro / about / contact), scroll vertically.
  if (!hall || !hall.contains(el)) {
    if (selector.includes("about-section") && window.__hscroll?.toAbout) {
      window.__hscroll.toAbout();
    } else if (selector.includes("contact-section")) {
      window.scrollTo({ top: el.offsetTop, behavior: "smooth" });
    } else if (selector.includes("newsletter-section")) {
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 120, behavior: "smooth" });
      const input = el.querySelector("input");
      let last = -1, still = 0;
      const tick = setInterval(() => {
        still = Math.abs(window.scrollY - last) < 1 ? still + 1 : 0;
        last = window.scrollY;
        if (still >= 2) { clearInterval(tick); input?.focus({ preventScroll: true }); }
      }, 120);
      setTimeout(() => clearInterval(tick), 4000);
    } else if (window.__hscroll?.toIntro) {
      window.__hscroll.toIntro();
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    return;
  }
  if (window.__hscroll) window.__hscroll.toElement(el);
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function TopNav({ gallery }) {
  return (
    <nav className="topnav" data-testid="topnav">
      <div className="topnav__group topnav__group--left">
        <button className="topnav__link" onClick={() => walkTo("[data-testid=hero-section]")} data-testid="nav-home">
          Home
        </button>
        <button className="topnav__link" onClick={() => walkTo("[data-testid=artwork-1]")} data-testid="nav-paintings">
          Paintings
        </button>
        <button className="topnav__link" onClick={() => walkTo("[data-testid=newsletter-section]")} data-testid="nav-updates">
          Get&nbsp;Updates
        </button>
        <Link to="/blog" className="topnav__link" data-testid="nav-blog">
          Blog
        </Link>
      </div>

      <button
        className="topnav__brand"
        onClick={() => walkTo("[data-testid=hero-section]")}
        data-testid="nav-brand"
      >
        {gallery.artist_name}
      </button>

      <div className="topnav__group topnav__group--right">
        <button className="topnav__link topnav__link--hide" onClick={() => walkTo("[data-testid=about-section]")} data-testid="nav-about">
          About
        </button>
        <button className="topnav__contact" onClick={() => walkTo("[data-testid=contact-section]")} data-testid="nav-contact">
          Contact
        </button>
      </div>
    </nav>
  );
}
